import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaInstagram, FaPhone, FaMapMarkerAlt, FaEnvelope } from "react-icons/fa";
import ScrollToTop from "../components/ScrollToTop";

const Contact = () => {
  const [phone, setPhone] = useState("0530 110 93 83");
  const [rawPhone, setRawPhone] = useState("905301109383");

  useEffect(() => {
    const fetchPhone = async () => {
      try {
        const res = await axios.get("https://api.pinkhomebalat.com/api/public/whatsapp");
        if (res.data.whatsapp_num) {
          const num = res.data.whatsapp_num;
          setRawPhone(num);
          let formatted = num.startsWith("90") ? "0" + num.substring(2) : num;
          formatted = formatted.replace(/(\d{4})(\d{3})(\d{2})(\d{2})/, "$1 $2 $3 $4");
          setPhone(formatted);
        }
      } catch (err) {
        console.error("İletişim numarası çekilemedi.");
      }
    };
    fetchPhone();
  }, []);

  return (
    <section className="py-24 bg-gray-50 min-h-screen">
      <ScrollToTop />
      <div className="container mx-auto px-4 max-w-5xl">
        <div className="bg-pink-100 p-10 rounded-lg shadow-lg">
          <h2 className="text-4xl font-bold text-[#d1935a] mb-10 text-center">İletişim</h2>
          
          <div className="grid md:grid-cols-2 gap-12">
            {/* Sol Taraf: Bilgiler */}
            <div className="space-y-8">
              <div>
                <h3 className="text-2xl font-semibold text-primary mb-4">Bize Ulaşın</h3>
                <p className="text-gray-700 mb-6">
                  Sorularınız veya rezervasyon talepleriniz için bizimle dilediğiniz zaman iletişime geçebilirsiniz.
                </p>
              </div>

              <div className="space-y-4">
                <a href="https://maps.google.com" target="_blank" rel="noopener noreferrer" 
                   className="flex items-center gap-x-4 text-gray-800 hover:text-[#d1935a] transition text-lg">
                  <FaMapMarkerAlt className="text-2xl text-[#d1935a]" /> 
                  <span>Balat, Akgül Sk. No:7, 34087 Fatih/İstanbul</span>
                </a>

                <a href={`tel:${rawPhone}`} className="flex items-center gap-x-4 text-gray-800 hover:text-[#d1935a] transition text-lg">
                  <FaPhone className="text-2xl text-[#d1935a]" /> 
                  <span>{phone}</span>
                </a>

                <a href="https://www.instagram.com/pinkhome.balat/" target="_blank" rel="noopener noreferrer" 
                   className="flex items-center gap-x-4 text-gray-800 hover:text-[#d1935a] transition text-lg">
                  <FaInstagram className="text-2xl text-[#d1935a]" /> 
                  <span>@pinkhome.balat</span>
                </a>
              </div>
            </div>

            {/* Sağ Taraf: Harita */}
            <div className="rounded-xl overflow-hidden shadow-md border-4 border-white">
              <iframe
                title="Balat Otel Konum"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6018.796470248209!2d28.9496597!3d41.0329824!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14caba46506e8d0f%3A0x622aeb5a8c746d!2sBalat%2C%20Akg%C3%BCl%20Sk.%20No%3A7%2C%2034087%20Fatih%2F%C4%B0stanbul!5e0!3m2!1str!2str!4v1693233115345!5m2!1str!2str"
                width="100%"
                height="350"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;